/**
 * Reusable client logo component with fallback for missing logos.
 */

import React from "react";
import { useClientLogo } from "../hooks/useClientLogo";

interface ClientLogoProps {
  clientId: string | null;
  className?: string;
  fallback?: React.ReactNode;
}

export const ClientLogo: React.FC<ClientLogoProps> = ({
  clientId,
  className = "h-16 object-contain",
  fallback = null,
}) => {
  const { logoPath, logoAlt } = useClientLogo(clientId);

  if (!logoPath) {
    return <>{fallback}</>;
  }

  return <img src={logoPath} alt={logoAlt} className={className} />;
};
